export const logKeys = () => {
    return [
        'is_active',
        'feedback_balance',
        'sms_balance',
        'devicelicense_account_count'
    ]
}